export const COUPON_STATUS = [
	'ACTIVE',
	'INACTIVE'
]

export const STATUS_FILTER_COLOR_MAPPING : {[key:string]: {[key:string]:string}} =  {
	ACTIVE: {
		button: 'bg-blue-light',
		count: 'bg-opacity-10 bg-white'
	},
	INACTIVE: {
		button: 'bg-white text-grey-dark font-medium text-sm',
		count: 'bg-grey-subtle'
	}
}

export const STATUS: CouponStatusFilter[] = [
	{
		key: 'ALL',
		label: 'Semua',
		count: 3
	},
	{
		key: 'ACTIVE',
		label: 'Active',
		count: 2
	},
	{
		key: 'INACTIVE',
		label: 'Inactive',
		count: 1
	}
]

export const DISCOUNT_TYPE = [
	{ label: 'PERCENT', value: 'PERCENT' },
	{ label: 'FIXED_DISCOUNT', value: 'FIXED_DISCOUNT' },
]

export const VISIBILITY_TYPE = [
	{ label: 'PRIVATE', value: 'PRIVATE' },
	{ label: 'PUBLIC', value: 'PUBLIC' },
]